<template>
  <v-container fluid>
    <section class="about" v-html="page.tekst"/>
    <section class="about-img">
      <img :src="$breakpoint.is.xs ? require('~/assets/img/over/familie-mob.png') : require('~/assets/img/over/familie.png')" alt="Familie Bos">
    </section>
  </v-container>
</template>

<script>
import page from '~/plugins/mixins/page';

export default {
  mixins: [page],
};
</script>

<style lang="sass" scoped>
.about
  ::v-deep .row
    align-items: center

    .col-12
      &:nth-of-type(4)
        padding: 0

.about-img
  transform: translateY(14%)

  img
    width: 100%
</style>
